import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { logOutUser } from '../../redux/auth/actions';
import { paths } from '../../routes';

const Logout = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    useEffect(() => {
        dispatch(logOutUser())
        history.push(paths.login)
        // eslint-disable-next-line
    }, [])

    return null;
}

export default Logout;
